import React, { type PropsWithChildren } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';

export type ScrollablePageProps = PropsWithChildren<{ 'data-testid'?: string }>;

export const ScrollablePage = ({ children, ...rest }: ScrollablePageProps): React.JSX.Element => (
	<Box
		testId={rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page'}
		xcss={scrollablePageStyles}
		paddingBlock="space.0"
		paddingInline="space.300"
	>
		{children}
	</Box>
);

export type PageLayoutProps = PropsWithChildren<{ hideMargin?: boolean; 'data-testid'?: string }>;

export const PageLayout = ({
	children,
	hideMargin,
	...rest
}: PageLayoutProps): React.JSX.Element => {
	return (
		<Box
			testId={rest['data-testid'] || 'spa-apps-page-layout.page.page-layout'}
			xcss={[
				hideMargin ? pageLayoutWithoutMarginStyles : pageLayoutWithMarginStyles,
				fg('global_rovo_button_in_jira_design_prereqs') &&
					additionalPaddingForGlobalRovoButtonStyles,
			]}
		>
			{children}
		</Box>
	);
};

const scrollablePageStyles = xcss({
	minWidth: '800px', // (gridSize * 90) + ((gridSize * 5) * 2)
	margin: 'space.0',
});

const pageLayoutWithoutMarginStyles = xcss({
	margin: 'space.0',
});

const pageLayoutWithMarginStyles = xcss({
	marginBlock: '0',
	marginInline: 'space.300',
});

const additionalPaddingForGlobalRovoButtonStyles = xcss({
	paddingBottom: 'space.500',
});
